import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Rol } from 'src/app/model/index.model';
import { BaseService } from './base.service';


@Injectable({
  providedIn: 'root'
})

export class RolService extends BaseService<Rol> {

  constructor(protected override http: HttpClient) {
    super(http, 'rol');
  }
}